module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG263233e301ec3b191fb4e43492e5caf6.263233e3.png";